module.exports = __webpack_public_path__ + "img/Device-Test2.de96cca0.png";